import i18next from "@/i18n";
import type { TOptions } from "i18next";

export const NOTIFICATIONS = {
  // SUCCESS
  SUCCESS_LOGIN: { message: i18next.t("success.login") },
  SUCCESS_RESTOCK: { message: i18next.t("success.restock") },
  SUCCESS_NEWSLETTER_SUBSCRIBE: { message: i18next.t("success.newsletter_subscribe") },
  SUCCESS_LOGOUT: { message: i18next.t("success.logout") },
  SUCCESS_CANCEL_ORDER: { message: i18next.t("success.cancel_order") },
  SUCCESS_MODIFY_ACCOUNT_INFO: { message: i18next.t("success.modify_account_info") },
  SUCCESS_TOSS_VALIDATE: { message: i18next.t("success.validate_toss") },

  // WARNING
  WARNING_PASSWORD_NOT_MATCH: { message: i18next.t("warning.not_match_password") },
  WARNING_PASSWORD_SAME_AS_BEFORE: { message: i18next.t("warning.same_password") },
  WARNING_NO_LOGIN: { message: i18next.t("warning.no_login") },
  WARNING_END_SESSION: { message: i18next.t("warning.end_session") },
  WARNING_NO_CART: { message: i18next.t("warning.no_cart") },
  WARNING_NO_PRODUCT: { message: i18next.t("warning.remove_product") },
  WARNING_OVER_PRODUCT: { message: i18next.t("warning.over_product") },
  WARNING_NO_RETURN: { message: i18next.t("warning.no_return_for_gift") },
  WARNING_NO_REASON: { message: i18next.t("warning.no_reason") },
  WARNING_NO_DETAIL_REASON: { message: i18next.t("warning.no_detail_reason") },
  WARNING_NO_RETURN_PRODUCTS: { message: i18next.t("warning.no_return_product") },
  WARNING_NO_IMAGE: { message: i18next.t("warning.no_image") },
  WARNING_SOCIAL_ACCOUNT: (social: TOptions) => ({ message: i18next.t("warning.social_account", social) }),
  WARNING_SAME_ACCOUNT_INFO: { message: i18next.t("warning.same_account_info") },
  WARNING_INVALID_SHIPPING_ADDRESS: { message: i18next.t("warning.necessary_invalid_shipping_address") },
  WARNING_EXCEEDED_PURCHASE_LIMIT: { message: i18next.t("warning.exceed_purchase_limit") },
  WARNING_RESTOCK: { message: i18next.t("warning.already_restock") },
  WARNING_NO_QUANTITY: { message: i18next.t("toast.account.warn.no_cart")},

  // ERROR
  ERROR_SERVER: { message: i18next.t("error.server") },
  ERROR_SEARCH: { message: i18next.t("error.search") },
  ERROR_CHECKOUT: { message: i18next.t("error.checkout") },
  ERROR_SELECT_OPTION: { message: i18next.t("error.select_option") },
  ERROR_DISCOUNT_CODE: { message: i18next.t("error.discount_code") },
  ERROR_CANCEL_ORDER: { message: i18next.t("error.cancel_order") },
  ERROR_NO_RETURN_PRODUCT: { message: i18next.t("error.failed_no_return_product") },
  ERROR_EXCEED_QTY: { message: i18next.t("error.exceed_qty") },
};
